import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'

const useGetEventDetail = (isAuto = true) => {
	const {idx} = useParams()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		let url = `/admin/event/${idx}/detail`

		isAuto && fetchRequest('GET', url)
	}, [])

	const request = (targetIdx) => {
		let url = `/admin/event/${targetIdx}/detail`

		fetchRequest('GET', url)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'event_idx')
					setAlert('대회 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, request, isLoading]
}

export default useGetEventDetail
